/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wise_Steep_Mallard_RushInputs */

const fr_wise_steep_mallard_rush = /** @type {(inputs: Wise_Steep_Mallard_RushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date anniversaire modifiée`)
};

/**

* @param {Wise_Steep_Mallard_RushInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const wise_steep_mallard_rush = /** @type {((inputs?: Wise_Steep_Mallard_RushInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wise_Steep_Mallard_RushInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_wise_steep_mallard_rush(inputs)
});